/* Shto wishlist hearts, saved to Swym (Wishlist Plus) when its app embed is on (client revision 2026-10-04).
   Any <button data-shto-wish="product-handle" data-shto-wish-pid="product id" data-shto-wish-vid="variant id"
   data-shto-wish-url="product url" aria-pressed="false"> toggles. Every heart for the same product on the page follows.
   - The shopper's Swym wishlist (their first list; made on the first save) decides which hearts are filled, once Swym
     is ready. Saves and removals go to Swym.
   - This browser also keeps a copy (localStorage "shto-wishlist"), so hearts show straight away on every page and still
     work if Swym is missing, slow, or refuses an item (e.g. its catalogue isn't synced yet). */
(function () {
  if (window.ShtoWish) return;
  var KEY = 'shto-wishlist';
  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
  var list = read();
  var swat = null, lid = null, creating = null;

  function paint(root) {
    (root || document).querySelectorAll('[data-shto-wish]').forEach(function (b) {
      b.setAttribute('aria-pressed', list.indexOf(b.getAttribute('data-shto-wish')) > -1 ? 'true' : 'false');
    });
  }

  function item(b) {
    var pid = Number(b.getAttribute('data-shto-wish-pid')), vid = Number(b.getAttribute('data-shto-wish-vid'));
    var url = b.getAttribute('data-shto-wish-url');
    if (!pid || !vid || !url) return null;
    return { empi: pid, epi: vid, du: new URL(url, location.origin).href };
  }

  // The shopper's list: their first Swym list, or a new one on the first save.
  function withList(done) {
    if (lid) return done(lid);
    if (!creating) {
      creating = new Promise(function (resolve) {
        swat.api.createList({ lname: 'My Wishlist' }, function (l) { lid = l && l.lid; resolve(lid); }, function () { resolve(null); });
      });
    }
    creating.then(function (id) { if (id) done(id); });
  }

  function sync(b, saved) {
    if (!swat) return;
    var it = item(b);
    if (!it) return;
    withList(function (id) {
      if (saved) swat.api.addToList(id, it, function () {}, function () {});
      else swat.api.deleteFromList(id, it, function () {}, function () {});
    });
  }

  // Swym's list wins once it loads: hearts for products on the page follow it (others keep this browser's copy).
  function load() {
    swat.api.fetchLists({
      callbackFn: function (lists) {
        var first = lists && lists[0];
        if (!first) return;
        lid = first.lid;
        var saved = (first.listcontents || []).map(function (x) { return Number(x.empi); });
        document.querySelectorAll('[data-shto-wish][data-shto-wish-pid]').forEach(function (b) {
          var handle = b.getAttribute('data-shto-wish'), on = saved.indexOf(Number(b.getAttribute('data-shto-wish-pid'))) > -1;
          var i = list.indexOf(handle);
          if (on && i < 0) list.push(handle);
          if (!on && i > -1) list.splice(i, 1);
        });
        write(list); paint();
      },
      errorFn: function () {}
    });
  }

  document.addEventListener('click', function (event) {
    var b = event.target.closest && event.target.closest('[data-shto-wish]');
    if (!b) return;
    event.preventDefault();
    var handle = b.getAttribute('data-shto-wish'), i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.push(handle);
    write(list); paint();
    sync(b, i < 0);
  });

  (window.SwymCallbacks = window.SwymCallbacks || []).push(function (s) {
    if (!s || !s.api || !s.api.fetchLists) return;
    swat = s;
    load();
  });

  window.ShtoWish = { paint: paint };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { paint(); }); else paint();
})();
